/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { useToast } from 'context/ToastContext';
import { toastConstant } from 'constants/toastmessage';
import { Controller, useForm } from 'react-hook-form';
import GlobalLoader from 'components/GlobalLoader/GlobalLoader';
import { ModalHeader } from 'shared/ModalHeader';
import TextSnippetWrapper from 'components/TextSnippetWrapper';
import { useUserDetailsContext } from 'context/userDetailsContext';
import { copyFileUrl } from 'services/fileManager/fileManagerServices';
import { convertToTimezoneFormatEndOfDay } from 'utils/utility_functions/timezone';
import { useFileManagerContext } from 'modules/FileManagerV2/context/FileManagerContext';
import TimezoneDatePicker from 'components/common/TimezoneDatePicker/TimezoneDatePicker';

export const FileSharingClientDetailsModal = ({ show, setShow, onHide, rowData }) => {
  const { addToast } = useToast();
  const { userDetails } = useUserDetailsContext();
  const { handleGetFiles, pageLimit } = useFileManagerContext();
  const timezoneBasedTime = new Date().toLocaleString('en-US', { timeZone: userDetails?.userDetails?.timezone });

  const { file_type, file_name, size, case_id, case_name, sk } = rowData;

  const { handleSubmit, control, reset } = useForm({ defaultValues: { nickname: '', lawft_link_expiry: '' } });

  const clearFormData = () => reset({ nickname: '', lawft_link_expiry: '' });

  const onSubmit = async (formData) => {
    const { nickname, lawft_link_expiry } = formData ?? {};
    const expiry = lawft_link_expiry ? convertToTimezoneFormatEndOfDay(lawft_link_expiry, userDetails?.timezone) : '';
    const hasValidCaseId = case_id && case_id !== 'undefined' && case_id !== '';

    const data = {
      files_shared: [
        {
          file_system_sk: sk,
          file_type,
          file_name,
          file_size: size,
        },
      ],
      nickname,
      lawft_link_expiry: expiry,
      ...(hasValidCaseId ? { case_id, case_name } : {}),
    };

    try {
      const response = await copyFileUrl({ data });
      const lawftLink = response?.data?.lawft_link;

      if (lawftLink) {
        try {
          await navigator?.clipboard?.writeText(lawftLink);
          addToast(false, toastConstant.toasterType.SUCCESS, toastConstant.api.SUCCESS, toastConstant.message.CLIPBOARD_COPY_SUCCCESS);
          setShow();
          clearFormData();
          handleGetFiles(pageLimit);
        } catch (clipboardError) {
          manualCopyFallback(lawftLink);
        }
      }
    } catch (error) {
      console.error('API call failed:', error);
      addToast(false, toastConstant.toasterType.ERROR, toastConstant.api.FAILED, toastConstant.message.CLIPBOARD_COPY_FAIL);
    }
  };

  const manualCopyFallback = (lawftLink) => {
    const tempInput = document.createElement('input');
    tempInput.value = lawftLink;
    document.body.appendChild(tempInput);
    tempInput.select();

    try {
      document.execCommand('copy');
      addToast(false, toastConstant.toasterType.SUCCESS, toastConstant.api.SUCCESS, toastConstant.message.CLIPBOARD_COPY_SUCCCESS);
      setShow();
      clearFormData();
      handleGetFiles(pageLimit);
    } catch (execCommandError) {
      addToast(false, toastConstant.toasterType.ERROR, toastConstant.api.FAILED, toastConstant.message.CLIPBOARD_COPY_FAIL);
    }
    document.body.removeChild(tempInput);
  };

  const handleHide = () => {
    onHide();
    clearFormData();
  };

  return (
    <>
      <Dialog
        header={ModalHeader}
        closable={false}
        visible={show}
        modal
        style={{ width: '30vw' }}
        onHide={handleHide}
        resizable={false}
        className=" create-msg-popup"
      >
        <GlobalLoader />

        <form>
          <div className="d-flex justify-content-between align-items-center mt-3  mb-3">
            <div className="modal-heading F-size16 text-bold">Lawft Link Details</div>
          </div>

          <div className="d-flex align-items-center py-2 flex-wrap">
            <div className="col-lg-3 col-12">
              <label className="p-medium"> Nickname {/* <span className="text-danger">*</span>{' '} */} </label>
            </div>

            <div className="col-lg-9 col-12">
              <Controller
                name="nickname"
                control={control}
                render={({ field }) => (
                  <TextSnippetWrapper
                    {...field}
                    type="text"
                    className="input-shadow w-100 p-2"
                    placeholder="Enter Nickname"
                    autoComplete="off"
                  />
                )}
              />
            </div>
          </div>

          <div className="d-flex align-items-center py-2 flex-wrap">
            <div className="col-lg-3 col-12">
              <label className="p-medium"> Expires on </label>
            </div>

            <div className="col-lg-9 col-12">
              <Controller
                name="lawft_link_expiry"
                control={control}
                render={({ field }) => (
                  <TimezoneDatePicker
                    id={field.name}
                    name="lawft_link_expiry"
                    value={field.value}
                    onChange={(selectedDate) => field.onChange(selectedDate)}
                    minDate={new Date(timezoneBasedTime)}
                    placeholder="Select"
                    monthNavigator
                    yearNavigator
                    yearRange="1950:2050"
                    className="input-shadow w-100"
                    timezone={userDetails?.timezone}
                    isEndOfDay={true}
                  />
                )}
              />
            </div>
          </div>
        </form>

        <div className="footer-btn">
          <Button className="p-button-secondary outline mx-2" label="Cancel" onClick={handleHide}></Button>
          <Button label={'Create & Copy Link '} className="p-button p-button-secondary" onClick={handleSubmit(onSubmit)} />
        </div>
      </Dialog>
    </>
  );
};
